import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'title', 'slug' ]

  create() {
    this.slugTarget.value = this.titleTarget.value.normalize('NFD').toLowerCase().replaceAll(/[\u0300-\u036f]/g, '').replaceAll(' ', '-')
  }
}
